var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page jobs" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("Navigation", {
                    attrs: {
                      page: "job-profiles",
                      "sub-link-active-key": "addJobProfile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h1", [_vm._v("Neuen Job anlegen")]),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("Loading")
                    : _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c(
                              "div",
                              { staticClass: "title-container" },
                              [
                                _c("SetJobProfileName", {
                                  on: { save: _vm.onAdd }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }